export default __webpack_public_path__ + "static/13-4586479e0f4326857fd906c5c3b504fd.jpg";